module.exports = __webpack_public_path__ + "static/media/JioType-Medium.9d5462aa.ttf";